import styled, { css } from "styled-components";
import { theme } from "../theme/lexusTheme";

export const Silver = styled.div`
    background-color: ${theme.colors.silver};
`;

export const Mist = styled.div`
    background-color: ${theme.colors.mist};
`;

// Animation to get a moving loading background. Based on car-filter v1 layout.
export const loadingBackgroundCss = css`
    background: linear-gradient(
        45deg,
        ${theme.colors.mist} 0%,
        ${theme.colors.white} 33%,
        ${theme.colors.mist} 66%,
        ${theme.colors.white} 100%
    );
    background-size: 400% 400%;
    animation: AnimationName 2s linear infinite;
    @keyframes AnimationName {
        0% {
            background-position: 100% 0%;
        }
        100% {
            background-position: 15% 100%;
        }
    }
`;
